<template>
  <div v-show="mapflag">
    <el-dialog 
      :title="$t('detailDepot_00043')" 
      :visible.sync="dialog_flag" 
      width="60%"
      :modal="false" 
      :lock-scroll='false'
      :modal-append-to-body="false"
      :close-on-click-modal="false"
      :before-close="handleClose">
      <div id="container">
        <el-row class="search">
          <el-input :placeholder="$t('detailDepot_00036')" v-model="search" size="medium">
            <el-button type="primary" slot="append" icon="el-icon-search" id="searchBtn" size="medium">{{$t('detailDepot_00037')}}</el-button>
          </el-input>
        </el-row>
        <div id="panel">
          <el-table
                ref="multipleTable"
                tooltip-effect="dark"
                :data="poiData"
                highlight-current-row
                @row-click="get_poi"
                :header-cell-style="{
                    background:'#EFF2F6',
                    color:'#000',
                    borderRadius: '4px 4px 0px 0px'}"
                style="width: 100%">

                <el-table-column width="32"></el-table-column>
                <el-table-column
                    :label="$t('detailDepot_00038')">
                    <template slot-scope="scope">
                        <span>{{scope.row.name}}</span>
                    </template>
                </el-table-column>
                <el-table-column
                    :label="$t('detailDepot_00039')">
                    <template slot-scope="scope">
                        <span>{{scope.row.address}}</span>
                    </template>
                </el-table-column>
            </el-table>
        </div>
      </div>
      <div slot="footer" class="dialog-footer">
          <div class="footer-piece-left">
            <div class="layout">{{$t('detailDepot_00040')}}：
                <span>{{map_Adress.province}}</span>
                <span v-if="!map_Adress.city==map_Adress.district">{{map_Adress.city}}</span>
                <span>{{map_Adress.district}}</span>
                <span>{{map_Adress.address}}</span>
            </div>
          </div>
          <div class="footer-piece-right">
            <el-button @click="handleClose" size="medium">{{isChange?$t('common_00303'):$t('detailDepot_00041')}}</el-button>
            <el-button type="primary" v-show="!isChange" @click="pull_address" size="medium">{{$t('detailDepot_00042')}}</el-button>
          </div>
        </div>
    </el-dialog>
  </div>

</template>

<script>
export default {
  data() {
    return {
      map_Adress: "",
      map_LnglatXY: "",
      poi_lnglat: "",
      dialog_flag: true,
      search: "",
      poiData: [],
      address:"",
      map:"",
      marker:"",
    };
  },
  props: ["mapflag","mapaddress","isChange"],
  watch:{
    mapaddress: function(newV, oldV) {
      let that = this;
      console.log(that.marker)
      if (that.marker) {
        that.marker.setMap(null);
        that.marker = null;
        that.map.clearMap();
      }
      that.map.setZoomAndCenter(17, [newV[0], newV[1]]);
      that.marker = new AMap.Marker({
        map: that.map,
        icon: "https://webapi.amap.com/theme/v1.3/markers/n/mark_b.png",
        position: [newV[0], newV[1]]
      });
      AMap.service("AMap.Geocoder", function() {
        var geocoder = new AMap.Geocoder({
          city: "010"
        });
        geocoder.getAddress(newV, function(status, result) {
          console.log(result)
          if (status === "complete" && result.info === "OK") {
            that.map_Adress = {
              province: result.regeocode.addressComponent.province,
              city:
                result.regeocode.addressComponent.city === ""
                  ? result.regeocode.addressComponent.district
                  : result.regeocode.addressComponent.city,
              district:
                result.regeocode.addressComponent.district === ""
                  ? result.regeocode.addressComponent.city
                  : result.regeocode.addressComponent.district,
              address:
                result.regeocode.addressComponent.township +
                result.regeocode.addressComponent.street +
                result.regeocode.addressComponent.streetNumber
            };
          } else {
            that.$message.error(that.$t('detailDepot_10021'));
          }
        });
      });
    },
    mapflag(val){
      if(val){
        this.dialog_flag = true;
      }
    }
  },
  methods: {
    handleClose() {
      this.dialog_flag = false;
      this.$emit("mapFlagDispatch", false);
      const map_fix_bg = document.getElementById('map_fix_bg');
      document.body.removeChild(map_fix_bg);
    },
    // 查询列表点击项
    get_poi(row) {
      this.poi_lnglat = {
        lng: row.location.lng,
        lat: row.location.lat
      };
    },
    // 结果的派发
    pull_address() {
      const get_address = Object.assign(this.map_Adress, this.map_LnglatXY);
      this.$emit("addressDispatch", get_address);
      this.handleClose();
    },
  },
  mounted() {
    setTimeout(()=>{
      this.$nextTick(function() {
        var that = this;
        // 绘制地图函数
        that.marker,
        that.map = new AMap.Map("container", {
            zoom: 10,
            resizeEnable: true
          });
        // document.getElementById("searchBtn").onclick = function() {
        //   AMap.service(["AMap.PlaceSearch"], function() {
        //     var placeSearch = new AMap.PlaceSearch({
        //       //构造地点查询类
        //       //city: "010",
        //       pageSize: 100
        //       //type: "商务住宅|公司企业|地名地址信息"
        //     });
        //     //关键字查询
        //     placeSearch.search(that.search, function(status, result) {
        //       console.log(result)
        //       if (status === "complete" && result.info === "OK") {
        //         that.poiData = result.poiList.pois;
        //         AMap.event.addDomListener(
        //           document.getElementById("panel"),
        //           "click",
        //           function() {
        //             add_Marker(that.poi_lnglat.lng, that.poi_lnglat.lat);
        //             getPositonName([that.poi_lnglat.lng, that.poi_lnglat.lat]);
        //             that.map_LnglatXY = {
        //               lng: that.poi_lnglat.lng,
        //               lat: that.poi_lnglat.lat
        //             };
        //           }
        //         );
        //       }
        //     });
        //   });
        // };
        // 监听地图点击事件
        AMap.event.addListener(that.map, "click", function(e) {
          add_Marker(e.lnglat.lng, e.lnglat.lat);
          getPositonName([e.lnglat.lng, e.lnglat.lat]);
          that.map_LnglatXY = {
            lng: e.lnglat.lng,
            lat: e.lnglat.lat
          };
        });
        // 添加标记
        function add_Marker(x, y) {
          if (that.marker) {
            that.marker.setMap(null);
            that.marker = null;
            that.map.clearMap();
          }
          that.map.setZoomAndCenter(17, [x, y]);
          that.marker = new AMap.Marker({
            map: that.map,
            icon: "https://webapi.amap.com/theme/v1.3/markers/n/mark_b.png",
            position: [x, y]
          });
        }
        // 经纬度转具体地址
        function getPositonName(lnglat) {
          console.log(lnglat)
          AMap.service("AMap.Geocoder", function() {
            //回调函数
            var geocoder = new AMap.Geocoder({
              city: "010"
            });
            geocoder.getAddress(lnglat, function(status, result) {
              if (status === "complete" && result.info === "OK") {
                that.map_Adress = {
                  province: result.regeocode.addressComponent.province,
                  city:
                    result.regeocode.addressComponent.city === ""
                      ? result.regeocode.addressComponent.district
                      : result.regeocode.addressComponent.city,
                  district:
                    result.regeocode.addressComponent.district === ""
                      ? result.regeocode.addressComponent.city
                      : result.regeocode.addressComponent.district,
                  address:
                    result.regeocode.addressComponent.township +
                    result.regeocode.addressComponent.street +
                    result.regeocode.addressComponent.streetNumber
                };
              } else {
                that.$message.error(that.$t('detailDepot_10021'));
              }
            });
          });
        }
      });
    },2000)
    
  }
};
</script>

<style lang="scss" scoped>
#container {
    height: 400px;
    position: relative;
}
.search {
    width: 350px;
    position: absolute;
    left: 30px;
    top: 20px;
    z-index: 2;
}
#panel {
    width: 360px;
    max-height: 400px;
    overflow: auto;
    position: absolute;
    top: 0;
    right: 0;
    z-index: 2;
}
.dialog-footer {
  display: flex;
  .footer-piece-left{
    text-align: left;
    flex: 1;
    .layout {
      margin: 10px 0;
      font-size: 14px;
      color: #1C2237;
    }
  }
  .footer-piece-right {
    width: 300px;
  }
}
/deep/ .el-dialog {
  border-radius: 6px;
}
/deep/ .el-dialog__header{
  font-size: 16px;
  border-top-left-radius: 6px;
  border-top-right-radius: 6px;
  background: #EFF2F6;
}
/deep/ .el-dialog__title{
  color: #8087A0;
}
</style>
